"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const zh_1 = require("../../../backend/src/app/acl_module/config/i18n/zh");
const zh_2 = __importDefault(require("./landing/zh"));
const onboarding_tooltip_1 = __importDefault(require("./zh/onboarding_tooltip"));
const knowledge_picker_1 = __importDefault(require("./zh/knowledge_picker"));
const knowledge_ragStatus_1 = __importDefault(require("./zh/knowledge_ragStatus"));
const knowledge_statusInfo_1 = __importDefault(require("./zh/knowledge_statusInfo"));
const app_page_1 = __importDefault(require("./zh/app_page"));
const app_intext_1 = __importDefault(require("./zh/app_intext"));
const modal_share_1 = __importDefault(require("./zh/modal_share"));
const modal_settings_1 = __importDefault(require("./zh/modal_settings"));
const chat_entry_1 = __importDefault(require("./zh/chat_entry"));
const user_form_1 = __importDefault(require("./zh/user_form"));
const slot_goal_1 = __importDefault(require("./zh/slot_goal"));
const slot_target_1 = __importDefault(require("./zh/slot_target"));
const slot_format_1 = __importDefault(require("./zh/slot_format"));
const slotData_create_1 = __importDefault(require("./zh/slotData_create"));
const slotData_load_1 = __importDefault(require("./zh/slotData_load"));
const slotData_form_1 = __importDefault(require("./zh/slotData_form"));
const slotData_type_1 = __importDefault(require("./zh/slotData_type"));
const app_pagination_1 = __importDefault(require("./zh/app_pagination"));
const payment_validation_1 = __importDefault(require("./zh/payment_validation"));
const payment_status_1 = __importDefault(require("./zh/payment_status"));
const payment_stripe_1 = __importDefault(require("./zh/payment_stripe"));
const payment_provider_1 = __importDefault(require("./zh/payment_provider"));
const payment_confirmed_1 = __importDefault(require("./zh/payment_confirmed"));
const route_payment_1 = __importDefault(require("./zh/route_payment"));
const payment_search_1 = __importDefault(require("./zh/payment_search"));
const payment_preview_1 = __importDefault(require("./zh/payment_preview"));
const user_roles_1 = __importDefault(require("./zh/user_roles"));
const user_grade_1 = __importDefault(require("./zh/user_grade"));
const userGroup_form_1 = __importDefault(require("./zh/userGroup_form"));
const userGroup_error_1 = __importDefault(require("./zh/userGroup_error"));
const user_profile_1 = __importDefault(require("./zh/user_profile"));
const company_preview_1 = __importDefault(require("./zh/company_preview"));
const company_tooltips_1 = __importDefault(require("./zh/company_tooltips"));
const company_form_1 = __importDefault(require("./zh/company_form"));
const access_status_1 = __importDefault(require("./zh/access_status"));
const access_list_1 = __importDefault(require("./zh/access_list"));
const avatar_processing_1 = __importDefault(require("./zh/avatar_processing"));
const avatar_form_1 = __importDefault(require("./zh/avatar_form"));
const webhook_eventTypes_1 = __importDefault(require("./zh/webhook_eventTypes"));
const webhook_cronIntervals_1 = __importDefault(require("./zh/webhook_cronIntervals"));
const tools_imgGen_1 = __importDefault(require("./zh/tools_imgGen"));
const tools_convoTags_1 = __importDefault(require("./zh/tools_convoTags"));
const tools_galleryTags_1 = __importDefault(require("./zh/tools_galleryTags"));
const tools_detectContactData_1 = __importDefault(require("./zh/tools_detectContactData"));
const tools_detectTasks_1 = __importDefault(require("./zh/tools_detectTasks"));
const tools_productCompare_1 = __importDefault(require("./zh/tools_productCompare"));
const tools_askForVoucher_1 = __importDefault(require("./zh/tools_askForVoucher"));
const tools_offerCreator_1 = __importDefault(require("./zh/tools_offerCreator"));
const tools_quickOffer_1 = __importDefault(require("./zh/tools_quickOffer"));
const tools_sendContactForm_1 = __importDefault(require("./zh/tools_sendContactForm"));
const tools_apiTool_1 = __importDefault(require("./zh/tools_apiTool"));
const tools_productAPISearch_1 = __importDefault(require("./zh/tools_productAPISearch"));
const tools_dynamicListings_1 = __importDefault(require("./zh/tools_dynamicListings"));
const tools_productCard_1 = __importDefault(require("./zh/tools_productCard"));
const tools_personalData_1 = __importDefault(require("./zh/tools_personalData"));
const tools_rag_1 = __importDefault(require("./zh/tools_rag"));
const tools_aiFormAnalyzer_1 = __importDefault(require("./zh/tools_aiFormAnalyzer"));
const avatar_common_1 = __importDefault(require("./zh/avatar_common"));
const avatar_active_1 = __importDefault(require("./zh/avatar_active"));
const avatar_tooltips_1 = __importDefault(require("./zh/avatar_tooltips"));
const avatar_knowledge_1 = __importDefault(require("./zh/avatar_knowledge"));
const avatar_preview_1 = __importDefault(require("./zh/avatar_preview"));
const style_form_1 = __importDefault(require("./zh/style_form"));
const accountGrade_list_1 = __importDefault(require("./zh/accountGrade_list"));
const accountGrade_form_1 = __importDefault(require("./zh/accountGrade_form"));
const limits_avatar_1 = __importDefault(require("./zh/limits_avatar"));
const limits_user_1 = __importDefault(require("./zh/limits_user"));
const limits_project_1 = __importDefault(require("./zh/limits_project"));
const limits_knowledge_1 = __importDefault(require("./zh/limits_knowledge"));
const limits_customModel_1 = __importDefault(require("./zh/limits_customModel"));
const limits_writingStyles_1 = __importDefault(require("./zh/limits_writingStyles"));
const limits_advanced_prompts_1 = __importDefault(require("./zh/limits_advanced-prompts"));
const limits_prompt_assist_1 = __importDefault(require("./zh/limits_prompt-assist"));
const limits_anti_hallucination_1 = __importDefault(require("./zh/limits_anti-hallucination"));
const limits_advanced_reports_1 = __importDefault(require("./zh/limits_advanced-reports"));
const limits_chat_thread_sharing_1 = __importDefault(require("./zh/limits_chat-thread-sharing"));
const limits_custom_branding_1 = __importDefault(require("./zh/limits_custom-branding"));
const limits_widgets_1 = __importDefault(require("./zh/limits_widgets"));
const limits_voice_agent_1 = __importDefault(require("./zh/limits_voice-agent"));
const limits_upgrade_1 = __importDefault(require("./zh/limits_upgrade"));
const voice_chat_error_1 = __importDefault(require("./zh/voice-chat_error"));
const email_pass_reset_1 = __importDefault(require("./zh/email_pass_reset"));
const email_activation_1 = __importDefault(require("./zh/email_activation"));
const email_upgrade_1 = __importDefault(require("./zh/email_upgrade"));
const email_payment_1 = __importDefault(require("./zh/email_payment"));
const register_complete_1 = __importDefault(require("./zh/register_complete"));
const password_reset_1 = __importDefault(require("./zh/password_reset"));
const accountGrade_preview_1 = __importDefault(require("./zh/accountGrade_preview"));
const table_controls_1 = __importDefault(require("./zh/table_controls"));
const route_settings_1 = __importDefault(require("./zh/route_settings"));
const route_style_1 = __importDefault(require("./zh/route_style"));
const route_company_1 = __importDefault(require("./zh/route_company"));
const route_user_1 = __importDefault(require("./zh/route_user"));
const route_accountGrade_1 = __importDefault(require("./zh/route_accountGrade"));
const route_userGroup_1 = __importDefault(require("./zh/route_userGroup"));
const route_user_group_1 = __importDefault(require("./zh/route_user_group"));
const route_branch_1 = __importDefault(require("./zh/route_branch"));
const route_profession_1 = __importDefault(require("./zh/route_profession"));
const route_avatar_1 = __importDefault(require("./zh/route_avatar"));
const route_conversation_1 = __importDefault(require("./zh/route_conversation"));
const route_botTest_1 = __importDefault(require("./zh/route_botTest"));
const route_tutorial_1 = __importDefault(require("./zh/route_tutorial"));
const tutorial_create_1 = __importDefault(require("./zh/tutorial_create"));
const tutorial_edit_1 = __importDefault(require("./zh/tutorial_edit"));
const tutorial_preview_1 = __importDefault(require("./zh/tutorial_preview"));
const tutorial_delete_1 = __importDefault(require("./zh/tutorial_delete"));
const tutorial_list_1 = __importDefault(require("./zh/tutorial_list"));
const tutorial_start_1 = __importDefault(require("./zh/tutorial_start"));
const tutorial_new_section_1 = __importDefault(require("./zh/tutorial_new-section"));
const tutorial_search_1 = __importDefault(require("./zh/tutorial_search"));
const tutorial_form_1 = __importDefault(require("./zh/tutorial_form"));
const tutorial_validation_1 = __importDefault(require("./zh/tutorial_validation"));
const tutorial_todos_1 = __importDefault(require("./zh/tutorial_todos"));
const tutorial_statistics_1 = __importDefault(require("./zh/tutorial_statistics"));
const tutorial_errors_1 = __importDefault(require("./zh/tutorial_errors"));
const botTest_create_1 = __importDefault(require("./zh/botTest_create"));
const botTest_edit_1 = __importDefault(require("./zh/botTest_edit"));
const botTest_tester_1 = __importDefault(require("./zh/botTest_tester"));
const botTest_target_1 = __importDefault(require("./zh/botTest_target"));
const botTest_list_1 = __importDefault(require("./zh/botTest_list"));
const botTest_actions_1 = __importDefault(require("./zh/botTest_actions"));
const botTest_preview_1 = __importDefault(require("./zh/botTest_preview"));
const botTest_testResults_1 = __importDefault(require("./zh/botTest_testResults"));
const route_ai_1 = __importDefault(require("./zh/route_ai"));
const ai_models_1 = __importDefault(require("./zh/ai_models"));
const ai_com_1 = __importDefault(require("./zh/ai_com"));
const ai_fields_1 = __importDefault(require("./zh/ai_fields"));
const ai_controls_1 = __importDefault(require("./zh/ai_controls"));
const ai_assist_suggestions_1 = __importDefault(require("./zh/ai-assist_suggestions"));
const ai_suggestions_1 = __importDefault(require("./zh/ai_suggestions"));
const autocomplete_triggers_1 = __importDefault(require("./zh/autocomplete_triggers"));
const ai_assist_1 = __importDefault(require("./zh/ai_assist"));
const conversation_type_1 = __importDefault(require("./zh/conversation_type"));
const conversation_agent_1 = __importDefault(require("./zh/conversation_agent"));
const conversation_session_1 = __importDefault(require("./zh/conversation_session"));
const conversation_avatar_1 = __importDefault(require("./zh/conversation_avatar"));
const conversation_voice_1 = __importDefault(require("./zh/conversation_voice"));
const conversation_clear_1 = __importDefault(require("./zh/conversation_clear"));
const conversation_auto_1 = __importDefault(require("./zh/conversation_auto"));
const conversation_start_1 = __importDefault(require("./zh/conversation_start"));
const conversation_stop_1 = __importDefault(require("./zh/conversation_stop"));
const conversation_recording_1 = __importDefault(require("./zh/conversation_recording"));
const recording_start_1 = __importDefault(require("./zh/recording_start"));
const recording_process_1 = __importDefault(require("./zh/recording_process"));
const conversation_end_1 = __importDefault(require("./zh/conversation_end"));
const message_send_1 = __importDefault(require("./zh/message_send"));
const microphone_access_1 = __importDefault(require("./zh/microphone_access"));
const conversation_interruption_1 = __importDefault(require("./zh/conversation_interruption"));
const conversations_search_1 = __importDefault(require("./zh/conversations_search"));
const conversations_date_1 = __importDefault(require("./zh/conversations_date"));
const conversations_error_1 = __importDefault(require("./zh/conversations_error"));
const conversations_delete_1 = __importDefault(require("./zh/conversations_delete"));
const conversations_favorite_1 = __importDefault(require("./zh/conversations_favorite"));
const route_knowledge_1 = __importDefault(require("./zh/route_knowledge"));
const route_knowledgeProject_1 = __importDefault(require("./zh/route_knowledgeProject"));
const knowledge_title_1 = __importDefault(require("./zh/knowledge_title"));
const knowledge_description_1 = __importDefault(require("./zh/knowledge_description"));
const knowledge_content_1 = __importDefault(require("./zh/knowledge_content"));
const knowledge_tags_1 = __importDefault(require("./zh/knowledge_tags"));
const knowledge_active_1 = __importDefault(require("./zh/knowledge_active"));
const knowledge_filter_1 = __importDefault(require("./zh/knowledge_filter"));
const knowledge_project_1 = __importDefault(require("./zh/knowledge_project"));
const project_form_1 = __importDefault(require("./zh/project_form"));
const project_name_1 = __importDefault(require("./zh/project_name"));
const project_description_1 = __importDefault(require("./zh/project_description"));
const project_icon_1 = __importDefault(require("./zh/project_icon"));
const knowledge_native_1 = __importDefault(require("./zh/knowledge_native"));
const knowledge_form_1 = __importDefault(require("./zh/knowledge_form"));
const knowledge_bulk_upload_1 = __importDefault(require("./zh/knowledge_bulk_upload"));
const knowledge_preview_1 = __importDefault(require("./zh/knowledge_preview"));
const knowledgeProject_form_1 = __importDefault(require("./zh/knowledgeProject_form"));
const knowledgeProject_name_1 = __importDefault(require("./zh/knowledgeProject_name"));
const knowledgeProject_description_1 = __importDefault(require("./zh/knowledgeProject_description"));
const knowledgeProject_icon_1 = __importDefault(require("./zh/knowledgeProject_icon"));
const chat_teaser_1 = __importDefault(require("./zh/chat_teaser"));
const chat_heading_1 = __importDefault(require("./zh/chat_heading"));
const chat_config_1 = __importDefault(require("./zh/chat_config"));
const chat_noCredits_1 = __importDefault(require("./zh/chat_noCredits"));
const file_upload_1 = __importDefault(require("./zh/file_upload"));
const file_clipboard_1 = __importDefault(require("./zh/file_clipboard"));
const trainer_reset_1 = __importDefault(require("./zh/trainer_reset"));
const trainer_tab_1 = __importDefault(require("./zh/trainer_tab"));
const trainer_upload_1 = __importDefault(require("./zh/trainer_upload"));
const trainer_config_1 = __importDefault(require("./zh/trainer_config"));
const chat_sync_1 = __importDefault(require("./zh/chat_sync"));
const ai_chat_1 = __importDefault(require("./zh/ai_chat"));
const branch_list_1 = __importDefault(require("./zh/branch_list"));
const branch_create_1 = __importDefault(require("./zh/branch_create"));
const branch_edit_1 = __importDefault(require("./zh/branch_edit"));
const branch_search_1 = __importDefault(require("./zh/branch_search"));
const branch_delete_1 = __importDefault(require("./zh/branch_delete"));
const branch_form_1 = __importDefault(require("./zh/branch_form"));
const profession_list_1 = __importDefault(require("./zh/profession_list"));
const profession_create_1 = __importDefault(require("./zh/profession_create"));
const profession_edit_1 = __importDefault(require("./zh/profession_edit"));
const profession_search_1 = __importDefault(require("./zh/profession_search"));
const profession_delete_1 = __importDefault(require("./zh/profession_delete"));
const profession_form_1 = __importDefault(require("./zh/profession_form"));
const step_list_1 = __importDefault(require("./zh/step_list"));
const step_create_1 = __importDefault(require("./zh/step_create"));
const step_edit_1 = __importDefault(require("./zh/step_edit"));
const step_search_1 = __importDefault(require("./zh/step_search"));
const step_delete_1 = __importDefault(require("./zh/step_delete"));
const step_form_1 = __importDefault(require("./zh/step_form"));
const question_list_1 = __importDefault(require("./zh/question_list"));
const question_create_1 = __importDefault(require("./zh/question_create"));
const question_edit_1 = __importDefault(require("./zh/question_edit"));
const question_search_1 = __importDefault(require("./zh/question_search"));
const question_delete_1 = __importDefault(require("./zh/question_delete"));
const question_form_1 = __importDefault(require("./zh/question_form"));
const question_type_1 = __importDefault(require("./zh/question_type"));
const onboarding_intro_1 = __importDefault(require("./zh/onboarding_intro"));
const onboarding_list_1 = __importDefault(require("./zh/onboarding_list"));
const onboarding_create_1 = __importDefault(require("./zh/onboarding_create"));
const onboarding_edit_1 = __importDefault(require("./zh/onboarding_edit"));
const onboarding_search_1 = __importDefault(require("./zh/onboarding_search"));
const onboarding_delete_1 = __importDefault(require("./zh/onboarding_delete"));
const onboarding_status_1 = __importDefault(require("./zh/onboarding_status"));
const onboarding_wizard_1 = __importDefault(require("./zh/onboarding_wizard"));
const onboarding_benefits_1 = __importDefault(require("./zh/onboarding_benefits"));
const onboarding_button_1 = __importDefault(require("./zh/onboarding_button"));
const onboarding_image_1 = __importDefault(require("./zh/onboarding_image"));
const onboarding_faq_1 = __importDefault(require("./zh/onboarding_faq"));
const onboarding_setup_1 = __importDefault(require("./zh/onboarding_setup"));
const onboarding_knowledge_1 = __importDefault(require("./zh/onboarding_knowledge"));
const onboarding_avatar_1 = __importDefault(require("./zh/onboarding_avatar"));
const onboarding_profession_1 = __importDefault(require("./zh/onboarding_profession"));
const voices_david_1 = __importDefault(require("./zh/voices_david"));
const voices_bradford_1 = __importDefault(require("./zh/voices_bradford"));
const voices_clyde_1 = __importDefault(require("./zh/voices_clyde"));
const voices_natalie_1 = __importDefault(require("./zh/voices_natalie"));
const voices_jane_1 = __importDefault(require("./zh/voices_jane"));
const voices_magdalena_1 = __importDefault(require("./zh/voices_magdalena"));
const onboarding_records_1 = __importDefault(require("./zh/onboarding_records"));
const onboarding_record_1 = __importDefault(require("./zh/onboarding_record"));
const onboarding_warning_1 = __importDefault(require("./zh/onboarding_warning"));
const onboarding_step_1 = __importDefault(require("./zh/onboarding_step"));
const onboarding_questions_1 = __importDefault(require("./zh/onboarding_questions"));
const onboarding_pagination_1 = __importDefault(require("./zh/onboarding_pagination"));
const onboarding_progress_1 = __importDefault(require("./zh/onboarding_progress"));
const onboarding_stats_1 = __importDefault(require("./zh/onboarding_stats"));
const onboarding_view_1 = __importDefault(require("./zh/onboarding_view"));
const onboarding_pick_1 = __importDefault(require("./zh/onboarding_pick"));
const onboarding_error_1 = __importDefault(require("./zh/onboarding_error"));
const onboarding_success_1 = __importDefault(require("./zh/onboarding_success"));
const onboarding_notify_1 = __importDefault(require("./zh/onboarding_notify"));
const login_username_1 = __importDefault(require("./zh/login_username"));
const login_password_1 = __importDefault(require("./zh/login_password"));
const login_form_1 = __importDefault(require("./zh/login_form"));
const register_name_1 = __importDefault(require("./zh/register_name"));
const register_username_1 = __importDefault(require("./zh/register_username"));
const register_email_1 = __importDefault(require("./zh/register_email"));
const register_password_1 = __importDefault(require("./zh/register_password"));
const register_repeat_password_1 = __importDefault(require("./zh/register_repeat_password"));
const register_form_1 = __importDefault(require("./zh/register_form"));
const register_company_1 = __importDefault(require("./zh/register_company"));
const activate_hero_1 = __importDefault(require("./zh/activate_hero"));
const activate_page_1 = __importDefault(require("./zh/activate_page"));
const activate_loading_1 = __importDefault(require("./zh/activate_loading"));
const activate_success_1 = __importDefault(require("./zh/activate_success"));
const activate_error_1 = __importDefault(require("./zh/activate_error"));
const activate_button_1 = __importDefault(require("./zh/activate_button"));
const settings_general_1 = __importDefault(require("./zh/settings_general"));
const settings_socialMedia_1 = __importDefault(require("./zh/settings_socialMedia"));
const settings_status_1 = __importDefault(require("./zh/settings_status"));
const settings_googleDrive_1 = __importDefault(require("./zh/settings_googleDrive"));
const googleDrive_picker_1 = __importDefault(require("./zh/googleDrive_picker"));
const account_upgrade_1 = __importDefault(require("./zh/account_upgrade"));
const account_grades_1 = __importDefault(require("./zh/account_grades"));
const settings_rag_1 = __importDefault(require("./zh/settings_rag"));
const rag_settings_1 = __importDefault(require("./zh/rag_settings"));
const settings_credit_1 = __importDefault(require("./zh/settings_credit"));
const rag_file_1 = __importDefault(require("./zh/rag_file"));
const route_reports_1 = __importDefault(require("./zh/route_reports"));
const reports_access_1 = __importDefault(require("./zh/reports_access"));
const reports_costReports_1 = __importDefault(require("./zh/reports_costReports"));
const reports_export_1 = __importDefault(require("./zh/reports_export"));
const reports_period_1 = __importDefault(require("./zh/reports_period"));
const chat_settings_1 = __importDefault(require("./zh/chat_settings"));
const config_tooltips_1 = __importDefault(require("./zh/config_tooltips"));
const share_conversation_1 = __importDefault(require("./zh/share_conversation"));
const reports_shared_1 = __importDefault(require("./zh/reports_shared"));
const acl_table_1 = __importDefault(require("./zh/acl_table"));
const shortcuts_button_1 = __importDefault(require("./zh/shortcuts_button"));
const shortcuts_table_1 = __importDefault(require("./zh/shortcuts_table"));
const shortcuts_knowledge_1 = __importDefault(require("./zh/shortcuts_knowledge"));
const shortcuts_new_1 = __importDefault(require("./zh/shortcuts_new"));
const shortcuts_settings_1 = __importDefault(require("./zh/shortcuts_settings"));
const shortcuts_find_1 = __importDefault(require("./zh/shortcuts_find"));
const shortcuts_prompt_1 = __importDefault(require("./zh/shortcuts_prompt"));
const currency_error_1 = __importDefault(require("./zh/currency_error"));
const nav_avatar_1 = __importDefault(require("./zh/nav_avatar"));
const nav_model_1 = __importDefault(require("./zh/nav_model"));
const nav_ai_1 = __importDefault(require("./zh/nav_ai"));
const googleDrive_directoryPicker_1 = __importDefault(require("./zh/googleDrive_directoryPicker"));
const knowledge_bulkUpload_1 = __importDefault(require("./zh/knowledge_bulkUpload"));
const dblogs_filter_1 = __importDefault(require("./zh/dblogs_filter"));
const dblogs_results_1 = __importDefault(require("./zh/dblogs_results"));
const dblogs_col_1 = __importDefault(require("./zh/dblogs_col"));
const dblogs_error_1 = __importDefault(require("./zh/dblogs_error"));
const dblogs_search_1 = __importDefault(require("./zh/dblogs_search"));
const dblogs_page_1 = __importDefault(require("./zh/dblogs_page"));
const route_dblogs_1 = __importDefault(require("./zh/route_dblogs"));
const db_operation_1 = __importDefault(require("./zh/db_operation"));
const socialMediaPlan_wip_1 = __importDefault(require("./zh/socialMediaPlan_wip"));
const socialMediaPlan_nav_1 = __importDefault(require("./zh/socialMediaPlan_nav"));
const socialMediaPlan_dashboard_1 = __importDefault(require("./zh/socialMediaPlan_dashboard"));
const socialMediaPlan_stat_1 = __importDefault(require("./zh/socialMediaPlan_stat"));
const socialMediaPlan_tab_1 = __importDefault(require("./zh/socialMediaPlan_tab"));
const socialMediaPlan_history_1 = __importDefault(require("./zh/socialMediaPlan_history"));
const socialMediaPlan_library_1 = __importDefault(require("./zh/socialMediaPlan_library"));
const socialMediaPlan_filter_1 = __importDefault(require("./zh/socialMediaPlan_filter"));
const socialMediaPlan_drawer_1 = __importDefault(require("./zh/socialMediaPlan_drawer"));
const socialMediaPlan_post_1 = __importDefault(require("./zh/socialMediaPlan_post"));
const socialMediaPlan_approvalQueue_1 = __importDefault(require("./zh/socialMediaPlan_approvalQueue"));
const socialMediaPlan_ai_1 = __importDefault(require("./zh/socialMediaPlan_ai"));
const socialMediaPlan_channels_1 = __importDefault(require("./zh/socialMediaPlan_channels"));
const socialMediaPlan_analytics_1 = __importDefault(require("./zh/socialMediaPlan_analytics"));
const socialMediaPlan_creator_1 = __importDefault(require("./zh/socialMediaPlan_creator"));
const socialMediaPlan_brief_1 = __importDefault(require("./zh/socialMediaPlan_brief"));
const socialMediaPlan_schedule_1 = __importDefault(require("./zh/socialMediaPlan_schedule"));
const socialMediaPlan_step_1 = __importDefault(require("./zh/socialMediaPlan_step"));
const whatsapp_settingsList_1 = __importDefault(require("./zh/whatsapp_settingsList"));
const whatsapp_settingsForm_1 = __importDefault(require("./zh/whatsapp_settingsForm"));
const whatsapp_settings_1 = __importDefault(require("./zh/whatsapp_settings"));
const whatsapp_groups_1 = __importDefault(require("./zh/whatsapp_groups"));
const whatsapp_commsType_1 = __importDefault(require("./zh/whatsapp_commsType"));
const whatsapp_sourceType_1 = __importDefault(require("./zh/whatsapp_sourceType"));
const whatsapp_trackLog_1 = __importDefault(require("./zh/whatsapp_trackLog"));
const whatsapp_dm_1 = __importDefault(require("./zh/whatsapp_dm"));
const whatsapp_dashboard_1 = __importDefault(require("./zh/whatsapp_dashboard"));
const activities_panel_1 = __importDefault(require("./zh/activities_panel"));
const whatsapp_groupForm_1 = __importDefault(require("./zh/whatsapp_groupForm"));
const route_whatsapp_1 = __importDefault(require("./zh/route_whatsapp"));
const whatsapp_tabs_1 = __importDefault(require("./zh/whatsapp_tabs"));
const whatsapp_threads_1 = __importDefault(require("./zh/whatsapp_threads"));
const whatsapp_email_1 = __importDefault(require("./zh/whatsapp_email"));
const whatsapp_directMessages_1 = __importDefault(require("./zh/whatsapp_directMessages"));
exports.default = {
    ...onboarding_tooltip_1.default,
    ...knowledge_picker_1.default,
    ...knowledge_ragStatus_1.default,
    ...knowledge_statusInfo_1.default,
    ...app_page_1.default,
    ...app_intext_1.default,
    ...modal_share_1.default,
    ...modal_settings_1.default,
    ...chat_entry_1.default,
    ...user_form_1.default,
    ...slot_goal_1.default,
    ...slot_target_1.default,
    ...slot_format_1.default,
    ...slotData_create_1.default,
    ...slotData_load_1.default,
    ...slotData_form_1.default,
    ...slotData_type_1.default,
    ...app_pagination_1.default,
    ...payment_validation_1.default,
    ...payment_status_1.default,
    ...payment_stripe_1.default,
    ...payment_provider_1.default,
    ...payment_confirmed_1.default,
    ...route_payment_1.default,
    ...payment_search_1.default,
    ...payment_preview_1.default,
    ...user_roles_1.default,
    ...user_grade_1.default,
    ...userGroup_form_1.default,
    ...userGroup_error_1.default,
    ...user_profile_1.default,
    ...company_preview_1.default,
    ...company_tooltips_1.default,
    ...company_form_1.default,
    ...access_status_1.default,
    ...access_list_1.default,
    ...avatar_processing_1.default,
    ...avatar_form_1.default,
    ...webhook_eventTypes_1.default,
    ...webhook_cronIntervals_1.default,
    ...tools_imgGen_1.default,
    ...tools_convoTags_1.default,
    ...tools_galleryTags_1.default,
    ...tools_detectContactData_1.default,
    ...tools_detectTasks_1.default,
    ...tools_productCompare_1.default,
    ...tools_askForVoucher_1.default,
    ...tools_offerCreator_1.default,
    ...tools_quickOffer_1.default,
    ...tools_sendContactForm_1.default,
    ...tools_apiTool_1.default,
    ...tools_productAPISearch_1.default,
    ...tools_dynamicListings_1.default,
    ...tools_productCard_1.default,
    ...tools_personalData_1.default,
    ...tools_rag_1.default,
    ...tools_aiFormAnalyzer_1.default,
    ...avatar_common_1.default,
    ...avatar_active_1.default,
    ...avatar_tooltips_1.default,
    ...avatar_knowledge_1.default,
    ...avatar_preview_1.default,
    ...style_form_1.default,
    ...accountGrade_list_1.default,
    ...accountGrade_form_1.default,
    ...limits_avatar_1.default,
    ...limits_user_1.default,
    ...limits_project_1.default,
    ...limits_knowledge_1.default,
    ...limits_customModel_1.default,
    ...limits_writingStyles_1.default,
    ...limits_advanced_prompts_1.default,
    ...limits_prompt_assist_1.default,
    ...limits_anti_hallucination_1.default,
    ...limits_advanced_reports_1.default,
    ...limits_chat_thread_sharing_1.default,
    ...limits_custom_branding_1.default,
    ...limits_widgets_1.default,
    ...limits_voice_agent_1.default,
    ...limits_upgrade_1.default,
    ...voice_chat_error_1.default,
    ...email_pass_reset_1.default,
    ...email_activation_1.default,
    ...email_upgrade_1.default,
    ...email_payment_1.default,
    ...register_complete_1.default,
    ...password_reset_1.default,
    ...accountGrade_preview_1.default,
    ...table_controls_1.default,
    ...route_settings_1.default,
    ...route_style_1.default,
    ...route_company_1.default,
    ...route_user_1.default,
    ...route_accountGrade_1.default,
    ...route_userGroup_1.default,
    ...route_user_group_1.default,
    ...route_branch_1.default,
    ...route_profession_1.default,
    ...route_avatar_1.default,
    ...route_conversation_1.default,
    ...route_botTest_1.default,
    ...route_tutorial_1.default,
    ...tutorial_create_1.default,
    ...tutorial_edit_1.default,
    ...tutorial_preview_1.default,
    ...tutorial_delete_1.default,
    ...tutorial_list_1.default,
    ...tutorial_start_1.default,
    ...tutorial_new_section_1.default,
    ...tutorial_search_1.default,
    ...tutorial_form_1.default,
    ...tutorial_validation_1.default,
    ...tutorial_todos_1.default,
    ...tutorial_statistics_1.default,
    ...tutorial_errors_1.default,
    ...botTest_create_1.default,
    ...botTest_edit_1.default,
    ...botTest_tester_1.default,
    ...botTest_target_1.default,
    ...botTest_list_1.default,
    ...botTest_actions_1.default,
    ...botTest_preview_1.default,
    ...botTest_testResults_1.default,
    ...route_ai_1.default,
    ...ai_models_1.default,
    ...ai_com_1.default,
    ...ai_fields_1.default,
    ...ai_controls_1.default,
    ...ai_assist_suggestions_1.default,
    ...ai_suggestions_1.default,
    ...autocomplete_triggers_1.default,
    ...ai_assist_1.default,
    ...conversation_type_1.default,
    ...conversation_agent_1.default,
    ...conversation_session_1.default,
    ...conversation_avatar_1.default,
    ...conversation_voice_1.default,
    ...conversation_clear_1.default,
    ...conversation_auto_1.default,
    ...conversation_start_1.default,
    ...conversation_stop_1.default,
    ...conversation_recording_1.default,
    ...recording_start_1.default,
    ...recording_process_1.default,
    ...conversation_end_1.default,
    ...message_send_1.default,
    ...microphone_access_1.default,
    ...conversation_interruption_1.default,
    ...conversations_search_1.default,
    ...conversations_date_1.default,
    ...conversations_error_1.default,
    ...conversations_delete_1.default,
    ...conversations_favorite_1.default,
    ...route_knowledge_1.default,
    ...route_knowledgeProject_1.default,
    ...knowledge_title_1.default,
    ...knowledge_description_1.default,
    ...knowledge_content_1.default,
    ...knowledge_tags_1.default,
    ...knowledge_active_1.default,
    ...knowledge_filter_1.default,
    ...knowledge_project_1.default,
    ...project_form_1.default,
    ...project_name_1.default,
    ...project_description_1.default,
    ...project_icon_1.default,
    ...knowledge_native_1.default,
    ...knowledge_form_1.default,
    ...knowledge_bulk_upload_1.default,
    ...knowledge_preview_1.default,
    ...knowledgeProject_form_1.default,
    ...knowledgeProject_name_1.default,
    ...knowledgeProject_description_1.default,
    ...knowledgeProject_icon_1.default,
    ...chat_teaser_1.default,
    ...chat_heading_1.default,
    ...chat_config_1.default,
    ...chat_noCredits_1.default,
    ...file_upload_1.default,
    ...file_clipboard_1.default,
    ...trainer_reset_1.default,
    ...trainer_tab_1.default,
    ...trainer_upload_1.default,
    ...trainer_config_1.default,
    ...chat_sync_1.default,
    ...ai_chat_1.default,
    ...branch_list_1.default,
    ...branch_create_1.default,
    ...branch_edit_1.default,
    ...branch_search_1.default,
    ...branch_delete_1.default,
    ...branch_form_1.default,
    ...profession_list_1.default,
    ...profession_create_1.default,
    ...profession_edit_1.default,
    ...profession_search_1.default,
    ...profession_delete_1.default,
    ...profession_form_1.default,
    ...step_list_1.default,
    ...step_create_1.default,
    ...step_edit_1.default,
    ...step_search_1.default,
    ...step_delete_1.default,
    ...step_form_1.default,
    ...question_list_1.default,
    ...question_create_1.default,
    ...question_edit_1.default,
    ...question_search_1.default,
    ...question_delete_1.default,
    ...question_form_1.default,
    ...question_type_1.default,
    ...onboarding_intro_1.default,
    ...onboarding_list_1.default,
    ...onboarding_create_1.default,
    ...onboarding_edit_1.default,
    ...onboarding_search_1.default,
    ...onboarding_delete_1.default,
    ...onboarding_status_1.default,
    ...onboarding_wizard_1.default,
    ...onboarding_benefits_1.default,
    ...onboarding_button_1.default,
    ...onboarding_image_1.default,
    ...onboarding_faq_1.default,
    ...onboarding_setup_1.default,
    ...onboarding_knowledge_1.default,
    ...onboarding_avatar_1.default,
    ...onboarding_profession_1.default,
    ...voices_david_1.default,
    ...voices_bradford_1.default,
    ...voices_clyde_1.default,
    ...voices_natalie_1.default,
    ...voices_jane_1.default,
    ...voices_magdalena_1.default,
    ...onboarding_records_1.default,
    ...onboarding_record_1.default,
    ...onboarding_warning_1.default,
    ...onboarding_step_1.default,
    ...onboarding_questions_1.default,
    ...onboarding_pagination_1.default,
    ...onboarding_progress_1.default,
    ...onboarding_stats_1.default,
    ...onboarding_view_1.default,
    ...onboarding_pick_1.default,
    ...onboarding_error_1.default,
    ...onboarding_success_1.default,
    ...onboarding_notify_1.default,
    ...login_username_1.default,
    ...login_password_1.default,
    ...login_form_1.default,
    ...register_name_1.default,
    ...register_username_1.default,
    ...register_email_1.default,
    ...register_password_1.default,
    ...register_repeat_password_1.default,
    ...register_form_1.default,
    ...register_company_1.default,
    ...activate_hero_1.default,
    ...activate_page_1.default,
    ...activate_loading_1.default,
    ...activate_success_1.default,
    ...activate_error_1.default,
    ...activate_button_1.default,
    ...settings_general_1.default,
    ...settings_socialMedia_1.default,
    ...settings_status_1.default,
    ...settings_googleDrive_1.default,
    ...googleDrive_picker_1.default,
    ...account_upgrade_1.default,
    ...account_grades_1.default,
    ...settings_rag_1.default,
    ...rag_settings_1.default,
    ...settings_credit_1.default,
    ...rag_file_1.default,
    ...route_reports_1.default,
    ...reports_access_1.default,
    ...reports_costReports_1.default,
    ...reports_export_1.default,
    ...reports_period_1.default,
    ...chat_settings_1.default,
    ...config_tooltips_1.default,
    ...share_conversation_1.default,
    ...reports_shared_1.default,
    ...acl_table_1.default,
    ...shortcuts_button_1.default,
    ...shortcuts_table_1.default,
    ...shortcuts_knowledge_1.default,
    ...shortcuts_new_1.default,
    ...shortcuts_settings_1.default,
    ...shortcuts_find_1.default,
    ...shortcuts_prompt_1.default,
    ...currency_error_1.default,
    ...nav_avatar_1.default,
    ...nav_model_1.default,
    ...nav_ai_1.default,
    ...googleDrive_directoryPicker_1.default,
    ...knowledge_bulkUpload_1.default,
    ...dblogs_filter_1.default,
    ...dblogs_results_1.default,
    ...dblogs_col_1.default,
    ...dblogs_error_1.default,
    ...dblogs_search_1.default,
    ...dblogs_page_1.default,
    ...route_dblogs_1.default,
    ...db_operation_1.default,
    ...socialMediaPlan_wip_1.default,
    ...socialMediaPlan_nav_1.default,
    ...socialMediaPlan_dashboard_1.default,
    ...socialMediaPlan_stat_1.default,
    ...socialMediaPlan_tab_1.default,
    ...socialMediaPlan_history_1.default,
    ...socialMediaPlan_library_1.default,
    ...socialMediaPlan_filter_1.default,
    ...socialMediaPlan_drawer_1.default,
    ...socialMediaPlan_post_1.default,
    ...socialMediaPlan_approvalQueue_1.default,
    ...socialMediaPlan_ai_1.default,
    ...socialMediaPlan_channels_1.default,
    ...socialMediaPlan_analytics_1.default,
    ...socialMediaPlan_creator_1.default,
    ...socialMediaPlan_brief_1.default,
    ...socialMediaPlan_schedule_1.default,
    ...socialMediaPlan_step_1.default,
    ...whatsapp_settingsList_1.default,
    ...whatsapp_settingsForm_1.default,
    ...whatsapp_settings_1.default,
    ...whatsapp_groups_1.default,
    ...whatsapp_commsType_1.default,
    ...whatsapp_sourceType_1.default,
    ...whatsapp_trackLog_1.default,
    ...whatsapp_dm_1.default,
    ...whatsapp_dashboard_1.default,
    ...activities_panel_1.default,
    ...whatsapp_groupForm_1.default,
    ...route_whatsapp_1.default,
    ...whatsapp_tabs_1.default,
    ...whatsapp_threads_1.default,
    ...whatsapp_email_1.default,
    ...whatsapp_directMessages_1.default,
    ...zh_2.default,
    'app.name': "IntHub",
    'knowledge.reindex': '重新索引',
    'knowledge.reindexingStarted': '重新索引已开始',
    'acl_resource.knowledge_group': '知识组',
    'acl_resource.payment': '支付',
    'acl_resource.botTest': '机器人测试',
    'app.removed': '已删除',
    'app.share': '分享',
    'app.share_link': '分享链接',
    'app.co_share': '与用户分享',
    // Modal headers
    // Chat
    'profile': '个人资料',
    'messages': '消息',
    'logout': '登出',
    'lang.en': '英语',
    'lang.de': '德语',
    'lang.es': '西班牙语',
    'lang.it': '意大利语',
    'lang.pl': '波兰语',
    'lang.zh': '中文',
    // User form language fields
    // 插槽选项
    'slot.none': '无',
    // 插槽占位符
    'slot.prompt_context': '主题',
    'slot.conversation_goal': '对话目标',
    'slot.conversation_target': '目标受众',
    'slot.conversation_format': '输出格式',
    // 插槽数据管理
    'slot-data.created': '插槽数据创建成功',
    'slot-data.deleted': '插槽数据删除成功',
    'pagination.itemsPerPage': '每页项目数',
    'pagination.ellipsis': '…',
    'search.placeholder': '搜索...',
    'search.clear': '清除搜索',
    'crud.create': '创建',
    'crud.edit': '编辑',
    'crud.delete': '删除',
    'crud.preview': '预览',
    'crud.saving': '保存中...',
    'crud.filtering': '筛选',
    'crud.searchPlaceholder': '搜索...',
    'crud.noCompanies': '未找到公司',
    'crud.noEntries': '未找到条目',
    'crud.failedToLoad': '加载数据失败',
    'crud.confirmDelete': '确定要删除',
    'crud.deletedSuccessfully': '删除成功',
    'crud.failedToDelete': '删除失败',
    // Form operations
    'form.back': '返回',
    // Common status translations
    'common.active': '活跃',
    'common.inactive': '不活跃',
    'common.common': '通用',
    'common.ordering': '排序',
    'common.createdAt': '创建时间',
    // Payment
    'payment.gateway': '支付网关',
    'payment.provider': '支付提供商',
    'payment.amount': '金额',
    'payment.description': '描述',
    'payment.sessionId': '会话ID',
    'payment.id': '支付ID',
    'payment.status': '支付状态',
    'payment.currentStatus': '当前状态',
    'payment.initiate': '初始化支付',
    'payment.testConnection': '测试连接',
    'payment.refreshStatus': '刷新状态',
    'payment.reset': '重置支付',
    'payment.defaultDescription': '支付交易',
    'payment.initialized': '支付初始化成功',
    'payment.initializationFailed': '支付初始化失败',
    'payment.successful': '支付成功完成',
    'payment.pending': '支付待处理',
    'payment.rejected': '支付被拒绝',
    'payment.error': '支付发生错误',
    'payment.connectionSuccessful': '支付提供商连接成功',
    'payment.connectionFailed': '支付提供商连接失败',
    'payment.statusCheckFailed': '支付状态检查失败',
    'payment.noPaymentId': '没有可用的支付ID',
    'payment.processing': '处理中...',
    'payment.confirmationFailed': '支付确认失败',
    'payment.unsupportedProvider': '不支持的支付提供商',
    'payment.selectProvider': '选择支付提供商',
    'payment.operationName': '支付操作',
    // Payment List & Preview
    'payment.user': '用户',
    'payment.email': '邮箱',
    'payment.targetGrade': '目标等级',
    'payment.paidAt': '付款时间',
    'payment.failureReason': '失败原因',
    'payment.details': '付款详情',
    'payment.timeline': '时间线',
    'payment.created': '创建时间',
    'payment.updated': '更新时间',
    'payment.technicalDetails': '技术详情',
    'payment.stripePaymentIntentId': 'Stripe付款意向ID',
    'payment.stripeCustomerId': 'Stripe客户ID',
    'payment.orderId': '订单ID',
    'payment.metadata': '元数据',
    // Gender
    'gender.male': '男性',
    'gender.female': '女性',
    'searchUser.users': '用户',
    'searchUser.searchPlaceholder': '搜索用户...',
    'searchUser.selectedParticipants': '已选参与者',
    'searchUser.availableUsers': '可用用户',
    'searchUser.noUsersFound': '未找到用户。',
    'searchUser.failedToLoadUsers': '加载用户失败',
    'user.name': '名字',
    'user.last_name': '姓氏',
    'user.username': '用户名',
    'user.email': '电子邮件',
    'user.parent': '上级用户',
    'user.role': '角色',
    'user.status': '状态',
    'user.company': '公司',
    'user.listTitle': '用户',
    'user.addUser': '添加用户',
    'user.searchPlaceholder': '搜索用户...',
    // User list component (for non-admin users)
    'userList.title': '团队成员',
    'userList.description': '与您的团队成员联系和协作',
    'userList.searchPlaceholder': '搜索团队成员...',
    'userList.noUsers': '未找到团队成员',
    'userList.loading': '加载团队成员中...',
    'userList.online': '在线',
    'userList.offline': '离线',
    'userList.lastSeen': '最后活跃时间',
    'userList.startChat': '开始聊天',
    'userList.viewProfile': '查看资料',
    // 用户组列表列
    'userGroup.name': '名称',
    'userGroup.description': '描述',
    'userGroup.active': '活跃',
    'userGroup.owner': '所有者',
    'userGroup.userCount': '用户数量',
    // 用户组列表页面
    'userGroup.listTitle': '用户组',
    'userGroup.addUserGroup': '添加用户组',
    'userGroup.searchPlaceholder': '搜索用户组...',
    // 用户组表单页面
    'userGroup.create': '创建用户组',
    // 用户表单
    // User form preview
    // User form errors
    // User profile
    'company.name': '名称',
    'company.nip': '税号',
    'company.email': '电子邮件',
    'company.phone': '电话',
    'company.city': '城市',
    'company.address': '地址',
    'company.street': '街道',
    'company.postalCode': '邮政编码',
    'company.website': '网站',
    'company.description': '描述',
    'company.modules': '模块',
    'company.active': '活跃',
    // Company Preview & Tooltips
    // Company form
    'access.user_or_company': '用户 / 公司',
    'access.user_group': '用户组',
    'access.policies': '访问策略',
    'access.active': '活跃',
    'avatar.image': '图片',
    'avatar.name': '名称',
    'avatar.gender': '性别',
    'avatar.age': '年龄',
    'avatar.model': '模型',
    'avatar.onboarded': '已入职',
    'avatar.processing': '处理中',
    'avatar.avatar': '头像',
    'avatar.description': '描述',
    'avatar.listTitle': '助手',
    'avatar.noAvatars': '未找到助手',
    'avatar.addAvatar': '添加助手',
    'avatar.searchPlaceholder': '搜索助手...',
    'avatar.listView': '列表视图',
    'avatar.gridView': '网格视图',
    // Avatar form knowledge section
    // Avatar form page
    // Webhook配置
    // Webhook定义
    // Webhook载荷示例
    // Webhook事件类型
    // 知识操作
    'knowledge.edit': '编辑知识',
    // Webhook定时间隔
    // 词汇表配置
    // API 工具
    'apiTool.requestSent': '请求已发送',
    'apiTool.requestFailed': '请求失败',
    'apiTool.collectingData': '正在收集数据...',
    'apiTool.response': '响应',
    'apiTool.noData': '暂无 API 请求数据',
    'tools.productCard': '产品卡片',
    'avatar.creator': '创建者',
    'avatar.voiceAgent': '语音代理',
    'avatar.common': '公共头像',
    'avatar.active': '活跃',
    'avatar.cantEditCommon': '无法编辑公共头像。只有超级管理员可以编辑公共头像。',
    'avatar.cantDeleteCommon': '无法删除公共头像。只有超级管理员可以删除公共头像。',
    // Avatar tooltips
    // Avatar knowledge management
    // Avatar preview page
    // Style List Columns
    'style.name': '名称',
    'style.description': '描述',
    'style.prompt': '提示词',
    'style.common': '通用样式',
    'style.active': '活跃',
    'style.style': '样式',
    // Style list page
    'style.listTitle': '写作样式',
    'style.addStyle': '添加写作样式',
    'style.searchPlaceholder': '搜索样式...',
    // Style form page
    'style.updated': '已更新',
    'style.created': '已创建',
    'style.update': '更新',
    'style.create': '创建',
    // 价格套餐 List Columns
    'accountGrade.name': '名称',
    'accountGrade.description': '描述',
    'accountGrade.advancedPrompts': '高级提示',
    'accountGrade.promptAssist': '提示助手',
    'accountGrade.maxAvatars': '最大头像数',
    'accountGrade.maxUsers': '最大用户数',
    'accountGrade.maxProjectsCount': '最大项目数',
    'accountGrade.maxKnowledgeEntries': '最大知识条目',
    'accountGrade.antiHallucination': '防幻觉',
    'accountGrade.advancedReports': '高级报告',
    'accountGrade.chatThreadSharing': '聊天线程共享',
    'accountGrade.customBranding': '自定义品牌',
    'accountGrade.widgets': '小部件',
    'accountGrade.customAiModels': '自定义AI模型',
    'accountGrade.voiceAgent': '语音代理',
    'accountGrade.writingStyles': '写作风格',
    'accountGrade.price': '月费',
    'accountGrade.yearlyPrice': '年费',
    'accountGrade.creditsPerMonth': '每月积分',
    'accountGrade.active': '活跃',
    'accountGrade.order': '顺序',
    // 价格套餐 list page
    'accountGrade.listTitle': '价格套餐',
    'accountGrade.noAccountGrades': '未找到价格套餐',
    'accountGrade.noResults': '未找到价格套餐',
    'accountGrade.addAccountGrade': '添加价格套餐',
    'accountGrade.add': '添加价格套餐',
    'accountGrade.createTitle': '创建价格套餐',
    'accountGrade.searchPlaceholder': '搜索价格套餐...',
    // 价格套餐 form page
    // 价格套餐 sections
    'accountGrade.previewTitle': '价格套餐预览',
    'accountGrade.basicInfo': '基本信息',
    'accountGrade.features': '功能',
    'accountGrade.status': '状态',
    'accountGrade.limits': '限制',
    'accountGrade.unlimited': '无限制',
    // Account limits and restrictions
    'limits.noAccountGrade': '未找到账户计划。请联系支持团队。',
    // Voice chat errors
    'voice_chat.session_timeout': '语音对话会话因不活动而超时。请开始新对话。',
    // Email translations
    // Account upgrade emails
    // Payment success emails
    // Payment failed emails
    // Common payment fields
    // Registration completion
    // Password Reset Page
    // Password Reset Confirm Page
    // 价格套餐 preview page
    'chatDemo.title': '聊天系统演示',
    'chatDemo.intro': '已实现完整的聊天会话历史系统。',
    'chatDemo.featuresTitle': '已实现功能：',
    'chatDemo.openChat': '打开聊天系统',
    'chatDemo.implementationTitle': '实现细节：',
    'chatDemo.backendModels': '后端模型：',
    'chatDemo.apiEndpoints': 'API端点：',
    'chatDemo.frontendComponents': '前端组件：',
    'home.dashboardArea': '仪表板区域',
    'form.label': '标签',
    'form.value': '值',
    'form.required': '必填',
    'form.optional': '可选',
    'login.usernameLabel': '登录名/邮箱',
    'login.passwordLabel': '密码',
    'login.forgotPassword': '忘记密码？',
    'login.submit': '登录',
    'register.nameLabel': '名字',
    'register.lastNameLabel': '姓氏',
    'register.usernameLabel': '登录名',
    'register.emailLabel': '电子邮件',
    'register.passwordLabel': '密码',
    'register.repeatPasswordLabel': '重复密码',
    'register.submit': '注册',
    // Route translations
    'route.dashboard': '仪表板',
    'route.companyManagement': '公司管理',
    'route.settings': '设置',
    'route.register': '注册',
    'route.profile': '个人资料',
    'route.assistants': '助手',
    'route.team': '团队',
    // Style routes
    'route.styles': '写作风格',
    // 路由
    'tutorial.noDescription': '无可用描述',
    'tutorial.steps': '步骤',
    'tutorial.sections': '部分',
    'tutorial.noTasks': '此部分没有可用任务',
    'tutorial.created': '教程创建成功',
    'tutorial.updated': '教程更新成功',
    'tutorial.saveFailed': '保存教程失败',
    'tutorial.loadFailed': '加载教程失败',
    'tutorial.loadListFailed': '加载教程列表失败',
    'tutorial.deleteFailed': '删除教程失败',
    // Form-related translations
    // Error messages
    // Additional validation messages
    'botTest.title': '机器人测试',
    'botTest.name': '测试名称',
    'botTest.date': '日期',
    'botTest.testDate': '测试日期',
    'botTest.description': '描述',
    'botTest.testers': '测试者',
    'botTest.targets': '目标',
    'botTest.messages': '消息',
    'botTest.noTesters': '没有可运行的测试者',
    'botTest.addTester': '添加测试者',
    'botTest.addTarget': '添加目标',
    'botTest.model': '模型',
    // Bot Test Preview
    // Bot Test Preview Tabs
    // Bot Test Results
    // Bot Test Results
    'route.ai': 'AI 聊天',
    'route.passwordReset': '密码重置',
    'route.passwordResetConfirm': '重置密码',
    'route.registerComplete': '注册完成',
    'route.activateAccount': '激活账户',
    'ai-assist.header': 'AI 助手',
    'ai-assist.minimize': '最小化',
    'ai-assist.expand': '展开',
    'ai-assist.info': 'AI助手将分析您的提示和对话，并提供建议以帮助获得更好的结果。您可以在聊天输入区域右下角的聊天设置中禁用它',
    'ai-assist.no-entries': '开始对话以激活AI助手帮助',
    'modelSelect.instruction': '选择您想要对话的头像或AI模型',
    'modelSelect.knowledgeCreatingInProgress': '正在创建知识库条目...',
    // AI Suggestions Component
    // Autocomplete Triggers Component
    // AI Assist Component
    // Model Select Component
    'modelSelect.models': '模型',
    'modelSelect.avatars': '头像',
    'modelSelect.liveChats': '实时聊天',
    'modelSelect.voiceModels': '语音模型',
    // 对话翻译
    'conversation.demo': '语音代理',
    'conversation.agent': '代理',
    'conversation.connected': '已连接',
    'conversation.disconnected': '已断开',
    'conversation.connecting': '正在连接...',
    'conversation.voice': '语音',
    'conversation.you': '您',
    'conversation.send': '发送',
    'conversation_agent.first_word': '您好！今天我可以如何帮助您？',
    'conversation.volume': '音量',
    'conversation.debug': '调试信息',
    'conversation.language': '语言',
    'conversation.messages': '消息',
    'conversation.started': '对话成功开始！',
    'conversation.ended': '对话已结束。',
    'conversation.error': '对话过程中发生错误。',
    'conversation.start': '开始对话',
    'conversation.end': '结束对话',
    'recording.start': '开始录音',
    'recording.stop': '停止录音',
    'message.used_tools': '使用的工具',
    'conversations.title': '对话',
    'conversations.loading': '加载对话中...',
    'conversations.retry': '重试',
    'conversations.empty': '未找到对话',
    'conversations.chat_history': '聊天历史',
    'conversations.no_conversations_yet': '暂无对话',
    'conversations.no_messages_yet': '暂无消息',
    'conversations.loading_more': '加载更多...',
    'conversations.no_more_conversations': '没有更多对话',
    'conversations.avatar': '头像',
    'conversations.new_chat': '新建话题',
    // 通用操作
    'common.create': '创建',
    'common.update': '更新',
    'common.cancel': '取消',
    'common.close': '关闭',
    'common.back': '返回',
    'common.clear': '清除',
    'common.moveUp': '上移',
    'common.moveDown': '下移',
    'common.delete': '删除',
    'common.none': '无',
    'common.pay': '支付',
    // 知识路由
    // 知识翻译
    'knowledge.create': '创建知识',
    'knowledge.title': '标题',
    'knowledge.description': '描述',
    'knowledge.content': '内容',
    'knowledge.file': '文件',
    'knowledge.tags': '标签',
    'knowledge.project': '项目',
    'knowledge.assigned': '已分配',
    'knowledge.createdAt': '创建时间',
    'knowledge.no_group': '无组',
    'knowledge.no_project': '无项目',
    'knowledge.active': '活跃',
    // Project translations
    'project.manage': '管理项目',
    'project.none': '无项目',
    'project.name': '项目名',
    'project.description': '描述',
    'project.color': '颜色',
    'project.icon': '图标',
    'project.isActive': '活跃',
    'project.preview': '预览',
    'project.list': '项目',
    'project.create': '添加项目',
    'project.edit': '编辑项目',
    'project.creator': '创建者',
    'knowledge.native': '原生知识',
    // 知识表单翻译
    // 知识批量上传翻译
    // Google Drive bulk upload
    // Google Drive bulk upload info
    // Knowledge preview
    'knowledge.preview': '知识预览',
    // Knowledge preview sections
    // Knowledge preview content type labels
    // Knowledge preview RAG status labels
    // Knowledge preview active status
    // Knowledge preview usage
    // 项目翻译
    // Project form
    // Project general
    'knowledgeProject.name': '项目名',
    'knowledgeProject.description': '描述',
    'knowledgeProject.color': '颜色',
    'knowledgeProject.icon': '图标',
    'knowledgeProject.isActive': '活跃',
    'knowledgeProject.preview': '预览',
    'knowledgeProject.list': '项目',
    'knowledgeProject.create': '添加项目',
    // Chat component translations
    'file.ext': '文件类型',
    'file.size': '文件大小',
    // LLM Trainer
    'trainer.title': 'LLM 模型训练器',
    'trainer.listTitle': "培训师列表",
    'trainer.jobId': "任务 ID",
    'trainer.modelName': "模型名称",
    'trainer.trainingType': "训练类型",
    'trainer.status': "状态",
    'trainer.createdAt': "创建于",
    'trainer.updatedAt': "更新于",
    'trainer.addJob': "添加作业",
    // Upload Component
    // Manual Entry
    // PDF Processing
    // Trainer config
    // 弹出消息
    'popup.error': '错误',
    'popup.alert': '提醒',
    'popup.confirm': '确认',
    'popup.ok': '确定',
    'popup.yes': '是',
    'popup.no': '否',
    "training_jobs.list": "训练作业列表",
    // CodeViewerComponent translations
    'code-viewer.show_code': '显示代码',
    'code-viewer.hide_code': '隐藏代码',
    'code-viewer.writing_code': '正在编写代码',
    // Branch translations
    'route.branches': '行业',
    'branch.name': '名称',
    'branch.description': '描述',
    'branch.color': '颜色',
    'branch.create': '创建行业',
    // Branch form page
    'branch.form.error.load_failed': "加载行业失败",
    'branch.form.error.action_failed': "操作失败",
    'branch.form.error.general_error': "发生错误",
    'branch.form.action.updated': "已更新",
    'branch.form.action.created': "已创建",
    'branch.form.action.update': "更新",
    'branch.form.action.create': "创建",
    'branch.form.success.updated': "行业更新成功",
    'branch.form.success.created': "行业创建成功",
    'branch.form.success.action_completed': "操作完成",
    // Profession translations
    'route.professions': '职业',
    'profession.name': '名称',
    'profession.description': '描述',
    'profession.branch': '行业',
    'profession.create': '创建职业',
    'profession.creator': '创建者',
    // Profession form
    // Step translations
    'route.steps': '步骤',
    'step.title': '标题',
    'step.description': '描述',
    'step.order': '顺序',
    'step.isShared': '共享',
    'step.profession': '职业',
    'step.create': '创建步骤',
    // Step form page
    // Question translations
    'route.questions': '问题',
    'question.title': '标题',
    'question.description': '描述',
    'question.type': '类型',
    'question.required': '必填',
    'question.order': '顺序',
    'question.step': '步骤',
    'question.create': '创建问题',
    // Question form (question manager)
    // Question types
    // Onboarding translations
    'route.onboardings': '入职',
    // Onboarding intro
    'onboarding.avatar': '头像',
    'onboarding.profession': '职业',
    'onboarding.status': '状态',
    'onboarding.currentStep': '当前步骤',
    'onboarding.createdAt': '创建时间',
    'onboarding.create': '开始入职',
    // Onboarding Wizard translations
    // Onboarding Component
    'onboarding.title': '入职培训',
    'onboarding.loading': '加载中...',
    // AI Onboarding page content
    // FAQ Section
    // Voice descriptions
    // Onboarding Records (for user-list component)
    'knowledge': '知识',
    // Additional onboarding translations
    'onboarding.filter': '筛选',
    'onboarding.progress': '进度',
    'onboarding.createdBy': '创建者',
    'pagination.previous': '上一页',
    'pagination.next': '下一页',
    'actions': '操作',
    'view': '查看',
    'edit': '编辑',
    'delete': '删除',
    'loading': '加载中...',
    // Onboarding view page
    // Onboarding pick page
    // Onboarding errors
    // Onboarding success messages
    // Additional onboarding fields
    'onboarding.fields_completed': '字段已完成',
    // Missing login/register keys not in main section
    // Registration Complete page
    // Account Activation page
    // Settings translations
    'settings.saveButton': '保存设置',
    'settings.savedSuccessfully': '设置保存成功',
    'settings.failedToSave': '保存设置失败',
    'settings.failedToLoad': '加载设置失败',
    // Settings Tabs
    'socialMediaPlan.brief.ctaPlaceholder': "输入行动号召...",
    "settings.socialMedia.dictionary.type.audience": "受众",
    // General Settings - Chat Learning
    // Google Drive Settings
    // Google Drive File Picker
    // Status indicators
    // Google Drive Status
    // Setup Instructions
    // How it works
    // Connected state
    // Common translations
    'common.loading': '加载中...',
    'common.showing': '显示',
    'common.to': '到',
    'common.of': '共',
    'common.next': '下一页',
    'common.previous': '上一页',
    'common.apply': '应用',
    'common.results': '条结果',
    'common.hide': '隐藏',
    // 账户管理
    // 账户级别
    // RAG Settings
    // RAG Settings Component
    // Knowledge Form RAG Override
    // Credit Settings
    // RAG File Operations
    // RAG Indexing Settings
    // RAG Search Settings
    // Resource translations
    'resource.active': '活跃',
    // Generated Image Component
    'gen-image.noData': '未提供图像数据',
    'gen-image.invalidData': '无效的图像数据格式',
    'gen-image.loadError': '加载图像失败',
    'gen-image.loading': '正在加载图像...',
    'gen-image.altText': '生成的图像',
    'gen-image.download': '下载',
    'gen-image.copyToClipboard': '复制到剪贴板',
    // File Card Component
    'file-card.errorLoading': '加载文件失败',
    'file-card.unknownFile': '未知文件',
    'file-card.unknownSize': '未知大小',
    'file-card.download': '下载',
    'file-card.addToKdb': '添加到知识库',
    'file-card.videoNotSupported': '您的浏览器不支持视频标签。',
    'file-card.zoomHint': '点击放大',
    'file-card.zoom': '放大',
    'file-card.close': '关闭',
    // Reports routes
    // Reports and Cost Analytics
    'reports.totalCost': '总成本',
    'reports.totalMessages': '总消息数',
    'reports.avgCostPerMessage': '平均每条消息成本',
    'reports.totalTokens': '总令牌数',
    'reports.filters': '筛选器',
    'reports.startDate': '开始日期',
    'reports.endDate': '结束日期',
    'reports.minCost': '最低成本',
    'reports.maxCost': '最高成本',
    'reports.userName': '用户名',
    'reports.companyName': '公司名称',
    'reports.userNamePlaceholder': '按用户名筛选...',
    'reports.companyNamePlaceholder': '按公司名称筛选...',
    'reports.avatarNamePlaceholder': '按头像名称筛选...',
    'reports.date': '日期',
    'reports.promptTokens': '提示令牌',
    'reports.completionTokens': '完成令牌',
    'reports.cost': '成本',
    'reports.cost_type': '查询类型',
    'reports.company': '公司',
    'reports.upstreamCost': '上游成本',
    'reports.reasoningTokens': '推理令牌',
    'reports.cachedTokens': '缓存令牌',
    'reports.noData': '无可用成本数据',
    'reports.noDataDescription': '未找到符合所选条件的使用成本数据。',
    'reports.failedToLoad': '加载成本数据失败',
    'reports.loadingError': '加载成本数据失败',
    'reports.user': '用户',
    'reports.costTrends': '成本和令牌趋势',
    'reports.showChart': '显示图表',
    'reports.tokens': '令牌',
    'report.usage_cost_data': '使用成本数据',
    'reports.userSummary': '用户汇总统计',
    'reports.messageCount': '消息数',
    'reports.avatarUsage': '头像使用统计',
    'reports.avgTokensPerMessage': '平均令牌/消息',
    'reports.firstUsage': '首次使用',
    'reports.lastUsage': '最后使用',
    // Chat Settings
    // Chat Config
    // Config Tooltips
    // Knowledge Database Tooltips
    'kdb.fullscan_tooltip': '文档全扫描将把整个文件放入提示中，导致更昂贵和更长的响应',
    // Share Conversation
    // AI Assistant Context
    'context.userMessages': '用户消息',
    'context.assistantMessages': '助手消息',
    'context.activeEntries': '活动条目',
    'context.summary': '上下文',
    'context.empty': '无可用上下文',
    'context.validationError': '上下文验证错误',
    // 报告
    'and': '和',
    // ACL Table
    // ACL Resource Descriptions
    'acl_resource_desc.company': '管理公司设置和信息',
    'acl_resource_desc.user': '管理用户账户和个人资料',
    'acl_resource_desc.user_group': '管理用户组及其权限',
    'acl_resource_desc.settings_general': '访问应用程序通用设置',
    'acl_resource_desc.settings_access': '管理访问控制和安全设置',
    'acl_resource_desc.settings_styles': '管理写作风格和模板',
    'acl_resource_desc.avatar': '创建和管理AI化身和助手',
    'acl_resource_desc.ai': '访问AI模型和配置',
    'acl_resource_desc.knowledge': '管理知识库和信息资源',
    'acl_resource_desc.project': '创建和管理项目和工作流程',
    'acl_resource_desc.onboarding': '管理用户入职流程和模板',
    'acl_resource_desc.reports': '生成和查看系统报告和分析',
    // ACL Action Descriptions
    'acl_action_desc.read': '查看和访问信息而不做更改',
    'acl_action_desc.write': '创建、编辑和修改内容及设置',
    'acl_action_desc.delete': '从系统中移除和永久删除项目',
    // V-Select Component
    'v-select.createNew': '新建',
    'v-select.noOptions': '无可用选项',
    // Keyboard shortcuts
    'shortcuts.title': '键盘快捷键',
    'shortcuts.tooltip-text': '查看可用的键盘快捷键',
    // Currency
    // Navigation
    'nav.credits': '积分',
    // Tools
    'tools.toolLabel': '工具',
    'tools.activeTools': '活跃工具',
    'tools.expandAll': '展开全部',
    'tools.collapseAll': '折叠全部',
    'tools.unknownTool': '未知工具',
    'tools.noActiveTools': '没有活跃工具',
    'tools.webSearch': '网络搜索',
    'tools.rag': '知识库',
    'webSearch.searching': '正在搜索网络',
    'webSearch.toolData': '网络搜索数据',
    'webSearch.searchingFor': '搜索',
    'webSearch.resultsFound': '找到结果',
    'webSearch.noResultsFound': '未找到结果',
    'webSearch.tryDifferentQuery': '尝试不同的搜索查询',
    'rag.searchingKnowledge': '搜索知识库',
    'rag.open_knowledge_preview': '打开知识预览',
    'rag.openInKnowledgeBase': '预览',
    'rag.noFilesIncluded': '未包含文件',
    'rag.sources_used': '使用的源',
    'rag.sources': '源',
    'rag.open_sources': '查看源',
    // Product Cards
    'productCard.toolData': '产品卡片',
    'productCard.productList': '产品列表',
    'productCard.singleProduct': '单个产品',
    'productCard.product': '产品',
    'productCard.products': '产品',
    'productCard.grossPrice': '含税价格',
    'productCard.netPrice': '净价',
    'productCard.vat': '增值税',
    'productCard.category': '分类',
    'productCard.viewProduct': '查看产品',
    'productCard.noProducts': '未找到产品',
    'productCard.trySearching': '尝试搜索产品',
    // Product Compare Tool
    'productCompare.domain': '域名',
    'productCompare.comparing': '对比',
    'productCompare.searchQuery': '搜索查询',
    'productCompare.noResults': '未找到对比结果',
    // Detect Contact Data Tool
    'detectContactData.phoneNumbers': '电话号码',
    'detectContactData.emails': '电子邮件',
    'detectContactData.addresses': '地址',
    'detectContactData.names': '姓名',
    'detectContactData.companies': '公司',
    'detectContactData.socialMedia': '社交媒体',
    'detectContactData.websites': '网站',
    'detectContactData.other': '其他',
    'detectContactData.noData': '未检测到联系数据',
    // Detect Tasks Tool
    'detectTasks.notes': '备注',
    'detectTasks.noTasks': '未检测到任务',
    // Offer Creator Tool
    'offerCreator.companyName': '公司名称',
    'offerCreator.firstName': '名',
    'offerCreator.lastName': '姓',
    'offerCreator.email': '电子邮件',
    'offerCreator.phone': '电话',
    'offerCreator.vatPayer': '增值税纳税人',
    'offerCreator.employeesNumber': '员工人数',
    'offerCreator.businessActivity': '经营活动',
    'offerCreator.taxationType': '税收类型',
    'offerCreator.documentsNumber': '文件数量',
    'offerCreator.packageId': '套餐',
    'offerCreator.additionalInfo': '附加信息',
    'offerCreator.formSent': '表单已提交',
    'offerCreator.noData': '未收集报价数据',
    // Quick Offer Tool
    'quickOffer.availableOptions': '可用选项',
    'quickOffer.formSent': '表单已提交',
    'quickOffer.noFields': '无表单字段',
    // Send Contact Form Tool
    'sendContactForm.name': '姓名',
    'sendContactForm.email': '电子邮件',
    'sendContactForm.phone': '电话',
    'sendContactForm.message': '消息',
    'sendContactForm.formSent': '联系表单已提交',
    'sendContactForm.noData': '无联系表单数据',
    // Conversation Tags Tool
    'convoTags.noTags': '未检测到标签',
    // Gallery Tags Tool
    'galleryTags.noTags': '未检测到画廊标签',
    // Ask For Voucher Tool
    'askForVoucher.detected': '已检测到优惠券请求',
    'askForVoucher.notDetected': '未检测到优惠券请求',
    // Dynamic Listings Tool
    'dynamicListings.listingsSignalled': '个列表已发送信号',
    'dynamicListings.allListings': '所有列表已发送信号',
    // Product API Search Tool
    'productAPISearch.searchQuery': '搜索查询',
    'productAPISearch.totalResults': '总结果数',
    'productAPISearch.subcategories': '子类别',
    'productAPISearch.noResults': '未找到结果',
    // Google Drive
    // Knowledge Bulk Upload
    // DB Logs page
    'dblogs.title': '数据库审计日志',
    'dblogs.show': '显示',
    'dblogs.hide': '隐藏',
    'dblogs.empty': '未找到日志条目。',
    // DB model collection names
    'model.user': '用户',
    'model.user_group': '用户组',
    'model.api_keys': 'API密钥',
    'model.acl_policy': 'ACL策略',
    'model.company': '公司',
    'model.conversation': '对话',
    'model.message': '消息',
    'model.avatar': '头像',
    'model.user_avatar': '用户头像',
    'model.knowledge': '知识',
    'model.knowledgeGroup': '知识组',
    'model.file': '文件',
    'model.training_job': '训练任务',
    'model.avatar_knowledge': '头像知识',
    'model.avatar_instruction': '头像指令',
    'model.avatar_instruction_version': '头像指令版本',
    'model.profession_knowledge': '职业知识',
    'model.profession_step': '职业步骤',
    'model.custom_models': '自定义模型',
    'model.embeddings': '嵌入',
    'model.branch': '分支',
    'model.profession': '职业',
    'model.step': '步骤',
    'model.step_profession': '职业步骤',
    'model.onboarding': '入职',
    'model.db_logs': '数据库日志',
    'model.question': '问题',
    'model.answer': '回答',
    'model.settings': '设置',
    'model.usage_cost': '使用成本',
    'model.knowledge_elevenlabs_mappings': 'ElevenLabs知识映射',
    'model.front_sync': '前端同步',
    'model.favorite_conversation': '收藏对话',
    'model.style': '风格',
    'model.slotData': '槽数据',
    'model.payments': '付款',
    'model.account_balance': '账户余额',
    'model.accountGrade': '账户等级',
    'model.currencyRate': '汇率',
    'model.test_result': '测试结果',
    'model.bot_test': '机器人测试',
    'model.bot_test_tester': '机器人测试员',
    'model.bot_test_target': '机器人测试目标',
    'model.tutorial': '教程',
    'model.tutorial_step': '教程步骤',
    'model.tutorial_section': '教程部分',
    'model.tutorial_section_knowledge': '教程部分知识',
    'model.tutorial_section_todo': '教程部分待办',
    'model.tutorial_participants': '教程参与者',
    'model.todo': '待办',
    'model.todo_item': '待办项目',
    'model.todo_item_value': '待办项目值',
    'model.cache': '缓存',
    'model.api_tool_definition': 'API工具定义',
    // DB operation names
    // WhatsApp settings
    'socialMediaPlan.title': '内容工作室', 'socialMediaPlan.failedToLoad': '加载失败', 'socialMediaPlan.newPost': '新建帖子', 'socialMediaPlan.library': '帖子库', 'socialMediaPlan.search': '搜索...', 'socialMediaPlan.edit': '编辑', "socialMediaPlan.schedule.action": '下一步？', 'socialMediaPlan.back': '返回', 'socialMediaPlan.next': '下一步', 'socialMediaPlan.cancel': '取消', 'socialMediaPlan.save': '确认并保存', 'socialMediaPlan.close': '关闭',
    'whatsapp.loginFailed': 'WhatsApp 登录失败。',
    'whatsapp.logoutSuccess': 'WhatsApp 已成功退出。',
    'whatsapp.logoutFailed': 'WhatsApp 退出失败。',
    'whatsapp.failedToLoad': '无法加载 WhatsApp 状态。',
    'whatsapp.entityIdRequired': '需要实体 ID。',
    'whatsapp.phoneRequired': '电话号码是必填项。',
    'whatsapp.settingsSaved': 'WhatsApp 设置已成功保存。',
    'whatsapp.settingsSaveFailed': '无法保存 WhatsApp 设置。',
    'whatsapp.agentStarted': 'WhatsApp 代理已成功启动。',
    'whatsapp.agentStartFailed': '无法启动 WhatsApp 代理。',
    'whatsapp.agentStopped': 'WhatsApp 代理已成功停止。',
    'whatsapp.agentStopFailed': '无法停止 WhatsApp 代理。',
    // WhatsApp settings list/form    
    // WhatsApp group
    // WhatsApp track logs
    // Activity panels
    // WhatsApp tabs
    // Comms Threads
    // WhatsApp email
    // WhatsApp direct messages
    // WhatsApp DM detail page
    // POP3 Email Reporting Settings
    'whatsapp.pop3SettingsSaved': '邮件设置保存成功。',
    'whatsapp.pop3SettingsSaveFailed': '保存邮件设置失败。',
    // ACL translations
    ...zh_1.aclTranslationsZh
};
